import { createApi } from '@reduxjs/toolkit/dist/query/react';
import axiosBaseQuery from '../../../axios/axiosBaseQuery';
import Util from '../../../util/Util';
import { Base64 } from '../../../util/Base64';
import { RightGroupAPIResponse, RightRoleAPIResponse } from './right.model';
import { RolesAdapter } from './RightAdapter';
import { UserService } from '../../users/api/UserService';

const baseUrl = new Util().getRightsServiceURL();

export const RightAPI = createApi({
  reducerPath: 'rightsAPI',
  baseQuery: axiosBaseQuery({ baseUrl }),
  tagTypes: ['rights-user'],
  endpoints(build) {
    return {
      getGroupUserRoles: build.query<RightGroupAPIResponse | undefined, string>(
        {
          query: (groupId) => ({
            url: `/group/${Base64.encode(groupId)}`,
          }),
          providesTags: (result, error, groupId) => {
            return result ? [{ type: 'rights-user', id: groupId }] : [];
          },
        }
      ),
      updateGroupUserRoles: build.mutation({
        async queryFn(arg: {
          userId: string;
          rolesId: string[];
          oldRolesId: string[];
          groupId: string;
        }) {
          const { userId, rolesId, oldRolesId, groupId } = arg;
          // Call the UserService to update roles for a user in a group
          const userService = new UserService();
          try {
            const response = await userService.putRolesGroupUser(
              userId,
              rolesId,
              oldRolesId,
              groupId
            );
            return { data: response };
          } catch (error) {
            return { error: error };
          }
        },
        invalidatesTags: (_result, _error, arg) => {
          return [{ type: 'rights-user', id: arg.groupId }];
        },
      }),
      getRoles: build.query({
        query: () => ({
          url: '/roles',
        }),
        // Transform the response to create dictionary by roles
        transformResponse: (response: RightRoleAPIResponse[]) => {
          return RolesAdapter.setAll(RolesAdapter.getInitialState(), response);
        },
      }),
    };
  },
});

export default RightAPI;
